export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
    <rect width="64" height="64" rx="14" fill="#064e3b" />
    <path d="M18 46 L32 16 L46 46" fill="none" stroke="#ffffff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24 36 H37" fill="none" stroke="#06b6d4" strokeWidth="4.5" strokeLinecap="round" />
    <circle cx="43" cy="36" r="4" fill="#d97706" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-9 w-9 shrink-0" />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-lg font-extrabold tracking-tight ${light ? "text-white" : "text-night"}`}>
        AURIK INGREVIA
      </span>
      <span className={`mt-1 font-mono text-[9px] uppercase tracking-[0.32em] ${light ? "text-emerald-300/80" : "text-teal-700"}`}>
        Feed Additive Science
      </span>
    </span>
  </span>
);

export default Logo;
